
import getIdToken from './getIdToken';

const fetchData = async ({ url, method = 'GET', body = null, headers = {} }) => {
        try{
            const idToken = await getIdToken();
            const options = {
                method,
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    'Content-Type': 'application/json',
                    ...headers
                },
            };

            if (body) {
                options.body = JSON.stringify(body);
            }

            const response = await fetch(url, options);
            const data = await response.json().catch(() => null);
            return data;
        }catch(error){
            console.log(error);
        }
    };

export default fetchData;